import API from '../api'
import deleteUrl from './paths'

export const deleteDispatchPlanInvoice = (dispatchPlanId, invoiceNumber, userId) =>
	new Promise((resolve, reject) => {
		API.delete(deleteUrl.deleteDispatchPlanInvoice, { dispatchPlanId, invoiceNumber, userId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})
